// Copyright (c) 2016 Deere & Company

import {createNewCustomer} from './create';
import {readCustomerDetails} from './details';
import {resetCustomerDetails} from './reset';
import {updateCustomerDetails} from './update-customer';

export default {
    createNewCustomer,
    readCustomerDetails,
    resetCustomerDetails,
    updateCustomerDetails
};



// WEBPACK FOOTER //
// ./src/customer/details/action-creators/index.js